module.exports = __webpack_public_path__ + "static/media/collect.3a30c5ee.jpg";